var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v("Notify Test")]),_c('v-card-text',[_c('v-btn',{on:{"click":_vm.notify}},[_vm._v("Send Notification")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }